export const marketplaceLinks = [
  { label: "Browse", href: "/marketplace", key: "browse" },
  { label: "Collector shops", href: "/marketplace/discover", key: "shops" },
  { label: "For you", href: "/marketplace/for-you", key: "personal" },
  { label: "Purchases", href: "/purchases", key: "buyer" },
  { label: "Sell", href: "/seller", key: "seller" },
] as const;

export function isMarketplacePath(path: string) {
  return (
    path === "/marketplace" ||
    path.startsWith("/marketplace/") ||
    path === "/seller" ||
    path.startsWith("/seller/") ||
    path === "/purchases"
  );
}

export function marketplaceArea(path: string) {
  if (
    path === "/seller" ||
    path.startsWith("/seller/") ||
    path.startsWith("/marketplace/capture/")
  )
    return "seller";
  if (path === "/purchases") return "buyer";
  if (path === "/marketplace/for-you") return "personal";
  if (
    path === "/marketplace/discover" ||
    path.startsWith("/marketplace/shops/")
  )
    return "shops";
  return "browse";
}

export function sellerView(search: string, hash = "") {
  // Older notification links still open the relevant sales queue or ledger.
  if (hash.startsWith("#order-") || hash === "#seller-activity")
    return "orders";
  if (hash.startsWith("#ledger-order-")) return "payouts";
  const view = new URLSearchParams(search).get("view");
  return view === "listings" || view === "payouts" || view === "settings"
    ? view
    : "orders";
}
